import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-merchant-dashboard',
  templateUrl: './merchant-dashboard.component.html',
  styleUrls: ['./merchant-dashboard.component.css']
})
export class MerchantDashboardComponent implements OnInit {
  merchant_id: string;
  merchantDetailsById: any;
  merchantName: any;
  merchantDetails: any;
  refresh:boolean=false;
  showNotification:boolean=false;
  showRejectNotification:boolean=false;

  constructor( private activatedRoute: ActivatedRoute,private adminService:AdminService) { }

  ngOnInit(): void {
    this.merchant_id = this.activatedRoute.snapshot.params.merchantId;
    this.merchantName = this.activatedRoute.snapshot.params.merchantName;
    this.refresh = false;
  }

  changeshowNotification(valueEmmitted){
    if(valueEmmitted){
      this.showNotification = true
    }
    setTimeout(()=>{                         
      this.showNotification = false;
  }, 4000);
  }

  rejectNotification(valueEmmitted){
    if(valueEmmitted){
      this.showRejectNotification = true;
    }
    setTimeout(()=>{                         
      this.showRejectNotification = false;
  }, 4000);

  }

  onTabChanged(event:any) {
    console.log(event)
    this.refresh = true;
  }

}
